import Modal from '../../Modal';
import {
  Title,
  SubTitle,
  FlowName,
  Footer,
  Container,
  DivIcon,
} from './styles';
import Button from '../../Button';
import Close from '../../../../assets/icons/Close';

import { usePromiseTracker } from 'react-promise-tracker';
import ReactLoading from 'react-loading';


const UndoFlowModal = ({
  isOpen,
  onClose,
  onConfirm,
  selector,
  className,
  flowName,
}) => {
  const { promiseInProgress } = usePromiseTracker({ area: 'undo-flow' });
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      selector={selector}
      className={className}
    >
      <Container>
        <Title>Desfazer última alteração?</Title>
        <SubTitle style={{ color: 'red' }}>Esta ação é irreversível.</SubTitle>

        {!promiseInProgress ? (
          <>
            <FlowName>{flowName}</FlowName>
            <Footer>
              <Button
                outline
                content="Cancelar"
                width={'11.3125rem'}
                height={'2.625rem'}
                onClick={onClose}
              />
              <Button
                content="Desfazer"
                width={'11.3125rem'}
                height={'2.625rem'}
                onClick={onConfirm}
              />
            </Footer>
          </>
        ) : (
          <div
            style={{
              margin: '0 auto',
              padding: '2rem',

            }}
          >
            <ReactLoading type="bars" color="#118052" />
          </div>

        )}

        <DivIcon>
          <Close onClick={onClose} />
        </DivIcon>
      </Container>
    </Modal>
  );
};

export default UndoFlowModal;
